import script from "./ProfilView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilView.vue?vue&type=script&setup=true&lang=js"

import "./ProfilView.vue?vue&type=style&index=0&id=6e138e0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e138e0e"]])

export default __exports__